// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.configuration_title__L7QWo {
  font-weight: 600;
  font-size: 32px;
  line-height: 150%;
  color: var(--HightEmphasis);
  margin-bottom: 40px; }

.configuration_tabs__DoUr3 {
  position: relative;
  display: flex;
  gap: 20px; }

.configuration_tab__XwCmQ {
  padding: 15px 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  text-decoration: none;
  transition: all 0.4s; }
  .configuration_tab__XwCmQ span {
    transition: all 0.4s; }

.configuration_active__Nu7Mi {
  color: #fe6100;
  border-bottom: 3px solid #FE6100; }

.configuration_noActive__0hmEK {
  color: #212121;
  border-bottom: 3px solid #FFFFFF; }
  .configuration_noActive__0hmEK:active span {
    color: #b62f00; }
  .configuration_noActive__0hmEK:hover {
    background: rgba(254, 97, 0, 0.1);
    border-bottom: 3px solid rgba(254, 97, 0, 0.1); }
    .configuration_noActive__0hmEK:hover span {
      color: #fe6100; }

.configuration_buttonPosition__hgAXT {
  position: fixed;
  top: 10px;
  right: 30px;
  z-index: 10; }
`, "",{"version":3,"sources":["webpack://./src/pages/configuration/configuration.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;ECFE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDEjB,2BAA2B;EAC3B,mBAAmB,EAAA;;AAErB;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS,EAAA;;AAGX;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB,EAAA;EAPtB;IASI,oBAAoB,EAAA;;AAGxB;EACE,cAAc;EACd,gCAAgC,EAAA;;AAElC;EACE,cAAc;EACd,gCAAgC,EAAA;EAFlC;IAKM,cAAc,EAAA;EALpB;IASI,iCAAiC;IACjC,8CAA8C,EAAA;IAVlD;MAYM,cAAc,EAAA;;AAIpB;EACE,eAAe;EACf,SAAQ;EACR,WAAW;EACX,WAAW,EAAA","sourcesContent":["@import '../../styles/media.scss';\n@import '../../styles/fonts.scss';\n\n.title {\n  @include h1;\n  color: var(--HightEmphasis);\n  margin-bottom: 40px;\n}\n.tabs {\n  position: relative;\n  display: flex;\n  gap: 20px;\n}\n\n.tab {\n  padding: 15px 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n  text-decoration: none;\n  transition: all 0.4s;\n  span{\n    transition: all 0.4s;\n  }\n}\n.active {\n  color: #fe6100;\n  border-bottom: 3px solid #FE6100;\n}\n.noActive {\n  color: #212121;\n  border-bottom: 3px solid #FFFFFF;\n  &:active {\n    span {\n      color: #b62f00;\n    }\n  }\n  &:hover {\n    background: rgba(254, 97, 0, 0.1);\n    border-bottom: 3px solid rgba(254, 97, 0, 0.1);\n    span {\n      color: #fe6100;\n    }\n  }\n}\n.buttonPosition{\n  position: fixed;\n  top:10px;\n  right: 30px;\n  z-index: 10;\n}","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `configuration_title__L7QWo`,
	"tabs": `configuration_tabs__DoUr3`,
	"tab": `configuration_tab__XwCmQ`,
	"active": `configuration_active__Nu7Mi`,
	"noActive": `configuration_noActive__0hmEK`,
	"buttonPosition": `configuration_buttonPosition__hgAXT`
};
export default ___CSS_LOADER_EXPORT___;
